import React from 'react';
import { Box, CircularProgress, Typography, Alert, Container } from '@mui/material';
import { useUserProfile } from '../hooks/useUserProfile';
import { useDetailFormData } from '../../detail-form';
import { DetailForm } from '../../detail-form';

export const MyProfilePage: React.FC = () => {
  const { userProfile, loading: profileLoading, error: profileError } = useUserProfile();

  const profileFormKey = userProfile?.ProfileFormKey;
  const userId = userProfile?.Id;

  const {
    detailMetadata,
    entity,
    initialValues,
    lookupMaps,
    lookupOptionMaps,
    lookupDataArrays,
    isLoading,
    isError,
  } = useDetailFormData({
    detailFormKey: profileFormKey,
    entityId: userId,
    mode: 'edit',
    skip: !profileFormKey || !userId,
  });

  if (profileLoading || isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
        <CircularProgress />
      </Box>
    );
  }

  if (profileError) {
    return (
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Alert severity="error">{profileError}</Alert>
      </Container>
    );
  }

  if (!profileFormKey) {
    return (
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Alert severity="warning">Profile form is not configured in the CMS.</Alert>
      </Container>
    );
  }

  if (isError || !detailMetadata || !entity) {
    return (
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Alert severity="error">Failed to load profile form data. Please try again later.</Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" mb={3} color="primary.main">
        {userProfile?.Name || 'User Profile'}
      </Typography>
      <DetailForm
        metadata={detailMetadata}
        initialValues={initialValues}
        mode="edit"
        basePath="/my-profile"
        lookupMaps={lookupMaps}
        lookupOptionMaps={lookupOptionMaps}
        lookupDataArrays={lookupDataArrays}
        detailFormKey={profileFormKey}
        menuItemId={detailMetadata.contentId}
        parentId={String(userId)}
        cancelBehavior="reset"
      />
    </Container>
  );
};
